import React from 'react';

const FormError = ({ message }) => {
  // standard form error
  return (
    <p className="sb-form-helptext sb-flex sb-helptext-error">
      <span className="sb-message-icon"></span> {message}
    </p>
  );
};

export default FormError;
